export default {
  list: '/portal/scenarios/',
  entity: '/portal/scenarios/:id/',
  tabHash: ['scenarios'],
}
